import { all, fork } from 'redux-saga/effects';

import { monetizationSagas } from './monetization/monetizationSagas';

export function* analyticsSagas() {
  yield all([monetizationSagas].map(saga => fork(saga)));
}
